export enum NewScanScheduleStep {
  ScanDetails = "SCAN_DETAILS",
  AttachProviders = "ATTACH_PROVIDERS",
  AttachWorkerPool = "ATTACH_WORKER_POOL",
  DefineScope = "DEFINE_SCOPE",
  Summary = "SUMMARY",
}

export type NewScanScheduleStepHeader = {
  title: string;
  description: string;
};
